// removed by extract-text-webpack-plugin
module.exports = {"main":"src-components-Invest-components-___CheckOption__main___1_0r4","mainAlt":"src-components-Invest-components-___CheckOption__mainAlt___26_Dm","checkBox":"src-components-Invest-components-___CheckOption__checkBox___toBaB","textBlock":"src-components-Invest-components-___CheckOption__textBlock___8UmCx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Invest/components/CheckOption.css
// module id = 984
// module chunks = 3